<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>权限管理/角色信息</span>
			</div>
			<div style="margin-top: 20px">
				<el-form :inline="true" class="demo-form-inline">
					<el-form-item>
						<el-button type="primary" @click="addRole">新增角色</el-button>
					</el-form-item>
				</el-form>
			</div>

			<div class="table_box">
				<tablec :tableData="tableData"></tablec>
			</div>
		</el-card>
	</div>
</template>

<script>
import tablec from "./tablec.vue";
import { getRolesLists } from "@/api/limitsauthority";
export default {
	components: { tablec },
	name: "",
	data() {
		return {
			tableData: [],
			total: 0,
			searchInfo: {
				page: 1,
				size: 10,
				truename: "",
				uid: "",
				auth_type: "",
				check_authentication: "",
			},
		};
	},
	created() {
		this.getDataList();
	},
	methods: {
		addRole() {
			this.$router.push({ path: "/limitsauthority/addrole" });
		},
		getDataList() {
			this.loading = true;
			getRolesLists(this.searchInfo)
				.then((res) => {
					if (res.code == 200) {
						this.tableData = res.data.data;
					} else {
						this.tableData = [];
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
	},
};
</script>

<style scoped></style>
